import { useState } from "react";

// Small shared hook for the "Advanced filters" collapsible used by the CDM
// finder / recall filter panels.
export const useAdvancedToggle = () => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const toggleAdvanced = () => setShowAdvanced((previous) => !previous);

  return { showAdvanced, toggleAdvanced };
};
